var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorysetAppData31399(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-app-data",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-app-data:not(.animated) .animable {opacity: 0;}svg#freepik_stories-app-data.animated\n        #freepik--Device--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite\n        linear floating;animation-delay: 0s,1s;}svg#freepik_stories-app-data.animated #freepik--Screen--inject-2\n        {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite linear\n        floating;animation-delay: 0s,1s;}svg#freepik_stories-app-data.animated #freepik--Character--inject-2 {animation:\n        1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;} @keyframes slideDown { 0% {\n        opacity: 0; transform: translateY(-30px); } 100% { opacity: 1; transform: translateY(0); } } @keyframes floating\n        { 0% { opacity: 1; transform: translateY(0px); } 50% { transform: translateY(-10px); } 100% { opacity: 1;\n        transform: translateY(0px); } } @keyframes slideLeft { 0% { opacity: 0; transform: translateX(-30px); } 100% {\n        opacity: 1; transform: translateX(0); } }\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 363.63px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 363.63,
    rx: 208.75,
    ry: 120.52,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 363.63px"
    },
    id: "elx3rmd2k6p2",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "269.571px 355.199px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.76,
    cy: 389.12,
    rx: 51.39,
    ry: 29.67,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "170.76px 389.12px"
    },
    id: "eljj2vt0er9ll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,330.11l135.64,78.33c3.81,2.2,10.48,1.92,14.88-.62L416.13,380c4.4-2.55,4.88-6.4,1.07-8.6L281.56,293.1c-3.82-2.21-10.48-1.93-14.89.61l-48.15,27.81C214.11,324.06,213.63,327.91,217.45,330.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "317.321px 350.766px"
    },
    id: "elax15qo4qyru",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2",
    className: "animable",
    style: {
      transformOrigin: "118.035px 73.1254px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.42,81l-6.75,3.84V82.47c0-.18,0-.35,0-.51s0-.33,0-.48v-.06h0c-.24-3.17-2.64-4.38-5.56-2.69a10.82,10.82,0,0,0-3.33,3.19c-.66-4.3-4.16-5.85-8.4-3.4-4.71,2.72-8.53,9.33-8.53,14.77v5.12a2.32,2.32,0,0,1-1.15,2l-4,2.33a5.74,5.74,0,0,0-2.83,4.94,2.36,2.36,0,0,0,3.54,2l36.9-21.31a6.45,6.45,0,0,0,3.22-5.58A2.09,2.09,0,0,0,117.42,81Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "98.7px 93.6761px"
    },
    id: "elur6umuuslvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92,38.92l-5,2.84V40c0-.12,0-.25,0-.37s0-.24,0-.36v0h0c-.18-2.34-1.95-3.24-4.12-2a8,8,0,0,0-2.45,2.36c-.49-3.18-3.09-4.33-6.22-2.51A13.92,13.92,0,0,0,132.82,48v3.79a1.71,1.71,0,0,1-.85,1.48L129,55a4.23,4.23,0,0,0-2.1,3.65,1.75,1.75,0,0,0,2.62,1.51l27.29-15.77a4.75,4.75,0,0,0,2.39-4.13A1.55,1.55,0,0,0,156.92,38.92Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "143.05px 48.323px"
    },
    id: "el8q87ujl98f5",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    className: "animable",
    style: {
      transformOrigin: "87.2905px 320.544px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.08,341.71l-10.42,6.06S98.92,331,96,314.07a32.72,32.72,0,0,0-4.24-11.25c-.82-1.7-7.11-12.24-1.58-17.1s18.53,4.8,17.95,30.83A101,101,0,0,1,104.08,341.71Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "98.0382px 316.139px"
    },
    id: "elvk3l9tu0pqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el09cxuszhw89d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.08,341.71l-10.42,6.06S98.92,331,96,314.07a32.72,32.72,0,0,0-4.24-11.25c-.82-1.7-7.11-12.24-1.58-17.1s18.53,4.8,17.95,30.83A101,101,0,0,1,104.08,341.71Z",
    style: {
      opacity: 0.5,
      transformOrigin: "98.0382px 316.139px"
    },
    className: "animable",
    id: "elfwvwbd7olvk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.24,344.9l-.13,0a.38.38,0,0,1-.22-.48c0-.11,3.93-10.92,3.72-28.32s-9.25-26.51-9.34-26.6a.37.37,0,0,1,.53-.53c.09.1,9.35,9.49,9.56,27.12s-3.73,28.48-3.77,28.59A.38.38,0,0,1,99.24,344.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "98.2648px 316.881px"
    },
    id: "ela0b27954d5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,346.45,78.77,356.58s-7.89-1.16-7.3-8.59,3.81-9.18-.19-12.44-5-3.48-4.83-6.68,2.35-4.59,3.36-5.86,3.83-3.92,1.85-7.78S67,307.65,71,305.88c2.38-1.06,6.39.26,9,3.09s4.85,4.85,7.37,5.5,7.77.71,7.59,5-1.3,5.84-.25,7.76C96.73,330.91,105.2,332.87,96,346.45Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "83.3181px 331.048px"
    },
    id: "eli0igwlber3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9fxgl5q39f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,346.45,78.77,356.58s-7.89-1.16-7.3-8.59,3.81-9.18-.19-12.44-5-3.48-4.83-6.68,2.35-4.59,3.36-5.86,3.83-3.92,1.85-7.78S67,307.65,71,305.88c2.38-1.06,6.39.26,9,3.09s4.85,4.85,7.37,5.5,7.77.71,7.59,5-1.3,5.84-.25,7.76C96.73,330.91,105.2,332.87,96,346.45Z",
    style: {
      opacity: 0.2,
      transformOrigin: "83.3181px 331.048px"
    },
    className: "animable",
    id: "ela9qyuphot5i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89,350.94h0a.36.36,0,0,1-.34-.4c0-.25,1.86-25.55-15.69-42.13a.38.38,0,1,1,.51-.55c17.81,16.84,15.94,42.49,15.92,42.74A.37.37,0,0,1,89,350.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "81.1326px 329.327px"
    },
    id: "el9agwek44ao9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.89,328.93h0a.38.38,0,0,1-.34-.4,15.25,15.25,0,0,1,5.58-10.87.37.37,0,0,1,.52.09.36.36,0,0,1-.08.52,14.66,14.66,0,0,0-5.28,10.31A.37.37,0,0,1,85.89,328.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "88.6382px 323.261px"
    },
    id: "elv73imwsjm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.16,333.31a.39.39,0,0,1-.28-.12c0-.05-4.4-4.73-14.32-3.37a.37.37,0,0,1-.42-.32.38.38,0,0,1,.32-.42c10.33-1.42,14.79,3.4,15,3.61a.38.38,0,0,1,0,.53A.38.38,0,0,1,87.16,333.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "79.8525px 331.066px"
    },
    id: "eloorvzgfm5eh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2",
    className: "animable",
    style: {
      transformOrigin: "335.19px 201.935px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.29,109.59c0-.13,0-.27,0-.41s0-.49-.08-.74-.05-.34-.07-.51-.07-.42-.11-.62-.07-.37-.11-.56-.09-.37-.13-.55-.1-.39-.16-.59l-.15-.49c-.07-.2-.13-.41-.21-.61s-.1-.28-.16-.43-.16-.43-.25-.64l-.15-.33A18.7,18.7,0,0,0,399,94.63L280.52,26.22a6,6,0,0,0-3.13-.82h0a19,19,0,0,0-9.74,2.68l-.43.25a10.55,10.55,0,0,0-4.87,6.7h0a6.23,6.23,0,0,0-.29,1.85v.53h0V293.13a18.63,18.63,0,0,0,9.32,16.13l118.49,68.41a6,6,0,0,0,3.12.83h2.33a10.59,10.59,0,0,0,5.41-1.49l4.73-2.81a5.87,5.87,0,0,0,2.86-5.05V367h0V110.77C408.32,110.38,408.31,110,408.29,109.59ZM270.49,31.24a6,6,0,0,1,.72.36A6,6,0,0,0,270.49,31.24Zm-1.79-.44-.44,0Zm1.55.35-.5-.16Zm-.79-.23-.46-.08ZM268,30.78l-.43,0Zm-.74.07c-.14,0-.27.06-.41.09C266.94,30.91,267.07,30.87,267.21,30.85Zm-1,.28-.28.1Zm-.69.29-.23.11Zm-.63.36-.18.12Zm-.58.42-.14.12Zm-.52.49a.6.6,0,0,0-.08.08A.6.6,0,0,1,263.74,32.69Zm130,345.75a5.11,5.11,0,0,1-.55.05A5.11,5.11,0,0,0,393.69,378.44Zm.25,0,.45-.1Zm.69-.16a4.57,4.57,0,0,0,.62-.22A4.57,4.57,0,0,1,394.63,378.24Zm2-1.05c.18-.14.35-.28.52-.44C397,376.91,396.85,377.05,396.67,377.19Zm-1.3.78c.17-.08.34-.16.51-.26C395.71,377.81,395.54,377.89,395.37,378Zm.72-.38.4-.26Zm2.88-4.43a6.49,6.49,0,0,0,0-.77A6.49,6.49,0,0,1,399,373.16Zm-1.74,3.54c.15-.15.29-.3.43-.47C397.52,376.4,397.38,376.55,397.23,376.7Zm.56-.64.29-.42Zm.41-.6c.11-.21.23-.42.32-.64C398.43,375,398.31,375.25,398.2,375.46Zm.33-.66a4.67,4.67,0,0,0,.23-.66A4.67,4.67,0,0,1,398.53,374.8Zm.29-.87c0-.18.08-.36.11-.54C398.9,373.57,398.86,373.75,398.82,373.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.19px 201.95px"
    },
    id: "elnvrficxgt4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,116.14A18.63,18.63,0,0,0,389.7,100L271.21,31.6A6.1,6.1,0,0,0,262.35,35a10.55,10.55,0,0,1,4.87-6.7l.43-.25a19,19,0,0,1,9.74-2.68h0a6,6,0,0,1,3.13.82L399,94.63a18.64,18.64,0,0,1,9.31,16.14V367a6.1,6.1,0,0,1-9.15,5.29l-.15-.09Z",
    style: {
      fill: "rgb(55, 72, 79)",
      transformOrigin: "335.33px 199.238px"
    },
    id: "elx4udede5n9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.38,309.26l118.49,68.41a6.1,6.1,0,0,0,9.15-5.28V116.14A18.63,18.63,0,0,0,389.7,100L271.21,31.6a6.1,6.1,0,0,0-9.15,5.28V293.13A18.63,18.63,0,0,0,271.38,309.26Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "330.54px 204.635px"
    },
    id: "el5m0n6af4468",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,372.39V116.14a18.6,18.6,0,0,0-1.84-8.06l9.16-5.67a18.61,18.61,0,0,1,2,8.36V369.15a5.87,5.87,0,0,1-2.86,5.05L400.73,377a10.59,10.59,0,0,1-5.41,1.49H393A6.11,6.11,0,0,0,399,372.39Z",
    style: {
      fill: "rgb(37, 50, 57)",
      transformOrigin: "400.66px 240.45px"
    },
    id: "ela8k116pzxv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.45,56.23V271.6a16.46,16.46,0,0,0,8.23,14.25l104.63,60.41a5.24,5.24,0,0,0,2.6.72,5.4,5.4,0,0,1-7.65,2.52L278.63,289.09a16.46,16.46,0,0,1-8.23-14.25V61.6A5.38,5.38,0,0,1,275.45,56.23Z",
    style: {
      fill: "rgb(55, 72, 79)",
      transformOrigin: "330.655px 203.227px"
    },
    id: "eluxtv98cs589",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.91,347a5.24,5.24,0,0,1-2.6-.72L283.68,285.85a16.46,16.46,0,0,1-8.23-14.25V56.23a7,7,0,0,1,3,.71l104.63,60.41a16.45,16.45,0,0,1,8.23,14.25V344.84a5.46,5.46,0,0,1-.45,2.17Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "333.38px 201.62px"
    },
    id: "elwpuwemd824g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcvp4ac0tt7v"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "333.38px 201.62px"
    },
    className: "animable",
    id: "elf0l5217ajzu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.91,347a5.24,5.24,0,0,1-2.6-.72L283.68,285.85a16.46,16.46,0,0,1-8.23-14.25V56.23a7,7,0,0,1,3,.71l104.63,60.41a16.45,16.45,0,0,1,8.23,14.25V344.84a5.46,5.46,0,0,1-.45,2.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "333.38px 201.62px"
    },
    id: "el1oxp7z0gcxu",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M347.12,85.78A4.17,4.17,0,0,0,349,89c1,.6,1.88.12,1.88-1.09A4.16,4.16,0,0,0,349,84.69C348,84.09,347.12,84.58,347.12,85.78Z",
    style: {
      fill: "rgb(37, 50, 57)",
      transformOrigin: "349px 86.8459px"
    },
    id: "elhhwosea4eff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.11,81.73A4.2,4.2,0,0,0,342,85c1,.6,1.88.11,1.88-1.09A4.19,4.19,0,0,0,342,80.64C341,80,340.11,80.53,340.11,81.73Z",
    style: {
      fill: "rgb(37, 50, 57)",
      transformOrigin: "341.995px 82.8112px"
    },
    id: "el39xdnoyzhbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.82,67.57l22.79,13.16c.9.52,1.63,0,1.63-1.23h0a3.92,3.92,0,0,0-1.63-3.12L311.82,63.22c-.9-.52-1.63,0-1.63,1.24h0A3.9,3.9,0,0,0,311.82,67.57Z",
    style: {
      fill: "rgb(37, 50, 57)",
      transformOrigin: "323.215px 71.9751px"
    },
    id: "elozeg91r6n7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.68,317.35a3.35,3.35,0,0,1,1.62.5l10.9,6.3c2.6,1.5,4.8,5.73,4.8,9.24,0,2.24-.88,3.68-2.25,3.68a3.27,3.27,0,0,1-1.62-.51l-10.9-6.29c-2.6-1.5-4.8-5.73-4.8-9.25,0-2.23.88-3.67,2.25-3.67h0m0-.93c-1.87,0-3.18,1.72-3.18,4.6,0,3.88,2.36,8.38,5.26,10.06l10.91,6.29a4.16,4.16,0,0,0,2.08.63c1.87,0,3.18-1.72,3.18-4.61,0-3.87-2.36-8.37-5.26-10.05l-10.91-6.29a4.16,4.16,0,0,0-2.08-.63Z",
    style: {
      fill: "rgb(37, 50, 57)",
      transformOrigin: "323.215px 327.21px"
    },
    id: "elok4dyaguh5a",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-2",
    className: "animable",
    style: {
      transformOrigin: "305.1px 232.468px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.91,146.69V388.1c0,4.38-1.61,7.31-4.06,8.28l-.07,0h0l-10.43,5.72.05-9.29,1.16-250.33,11-5.63A23.75,23.75,0,0,1,375.91,146.69Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "368.63px 269.475px"
    },
    id: "elc2oh8qaa6bv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.83,403l.06-10.14,1.16-250.63,11.75-6,.22.47a24.38,24.38,0,0,1,2.39,10V388.1c0,4.4-1.64,7.67-4.38,8.74h0Zm2.22-260.16-1.16,250-.05,8.43,9.78-5.35c2.39-.94,3.79-3.86,3.79-7.83V146.69a23.2,23.2,0,0,0-2.08-9.13Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "368.62px 269.615px"
    },
    id: "el2r95nxohptm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.57,136.88l-11,5.63L244.64,73.92l-7.88-4.58,10.88-6.13L248,63h0c1.74-1,4-1,6.51.47l111.62,64.45C369.08,129.66,371.77,133,373.57,136.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "305.165px 102.405px"
    },
    id: "elgbjs9z9o95b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.55,143a.54.54,0,0,1-.25-.06L236.51,69.77a.52.52,0,0,1-.25-.44.49.49,0,0,1,.26-.43l11.1-6.26.08-.06c2-1.18,4.45-1,7,.47l111.62,64.44c3,1.72,5.78,5.07,7.69,9.18a.48.48,0,0,1-.22.65l-11,5.64A.46.46,0,0,1,362.55,143ZM237.77,69.34l124.8,72.6,10.34-5.29a19.35,19.35,0,0,0-7.08-8.29L254.21,63.92c-2.2-1.28-4.3-1.46-5.92-.52l-.08.05-.31.19Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "305.161px 102.404px"
    },
    id: "el10ry8dox1uti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,152.76V393.08c0,3.79-1.21,6.51-3.13,7.79l-.63.34c-1.68.79-3.78.62-6.06-.7l-54-31.15-57.66-34.7a20.94,20.94,0,0,1-9.83-17.37V77c0-3.66,1.12-6.31,2.93-7.64a4.52,4.52,0,0,1,1-.57c1.64-.7,3.69-.49,5.9.78l111.62,65.53a16.81,16.81,0,0,1,7.27,7.43A23.84,23.84,0,0,1,365.1,152.76Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "299.445px 235.04px"
    },
    id: "elqd1x7qb1eg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.66,334.66c23,13.7,82.72,49.36,112.29,67.17a5.81,5.81,0,0,0,8.81-5V149.73a16.12,16.12,0,0,0-8-13.9L243.12,69.21a5.81,5.81,0,0,0-8.74,5V318.3A19,19,0,0,0,243.66,334.66Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "299.57px 235.541px"
    },
    id: "eljkvvzsz8btd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.41,335.09q27.66,16.5,55.31,33,16.15,9.64,32.3,19.32l14.43,8.66,6.43,3.86c1.92,1.16,4,2.86,6.26,3.16a6.41,6.41,0,0,0,7.12-6.31c0-.43,0-.86,0-1.3V167.88c0-5.93,0-11.86,0-17.79a17.07,17.07,0,0,0-8.49-14.86L349,130.66l-37.22-21.81L267.57,83c-8-4.67-15.9-9.43-23.92-14a6.41,6.41,0,0,0-9.77,5.66c0,2,0,3.91,0,5.86V298.24q0,9.69,0,19.4a20.06,20.06,0,0,0,9.53,17.45c.55.34,1.05-.53.5-.87-6.08-3.73-9-10-9-17v-224c0-6.15,0-12.31,0-18.46a5.76,5.76,0,0,1,1.81-4.56c2.09-1.79,4.65-1.47,6.84-.19l8.8,5.15L290,97.27l43.18,25.3c7.71,4.52,15.44,9,23.13,13.55a16.14,16.14,0,0,1,7.95,14.23V395.1c0,.54,0,1.07,0,1.6a5.39,5.39,0,0,1-8.34,4.53c-9.07-5.35-18.05-10.85-27.09-16.26q-31.35-18.78-62.72-37.5l-22.2-13.25C243.36,333.89,242.86,334.76,243.41,335.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "299.568px 235.588px"
    },
    id: "elmrlp5exlg2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.37,247.75a9.08,9.08,0,0,1,4.54,7.86h0a4.08,4.08,0,0,1-6.12,3.53l-96-55.44a9.09,9.09,0,0,1-4.53-7.86h0a4.07,4.07,0,0,1,6.11-3.53Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "299.585px 225.724px"
    },
    id: "elii0lgu16i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,236.09l-97-56a8.58,8.58,0,0,1-4.28-7.43V111.83a3.58,3.58,0,0,1,5.36-3.1l97,56a8.58,8.58,0,0,1,4.29,7.43V233A3.59,3.59,0,0,1,347.54,236.09Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "299.585px 172.409px"
    },
    id: "el6mcx85pb8qj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx19x93xgia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.54,236.09l-97-56a8.58,8.58,0,0,1-4.28-7.43V111.83a3.58,3.58,0,0,1,5.36-3.1l97,56a8.58,8.58,0,0,1,4.29,7.43V233A3.59,3.59,0,0,1,347.54,236.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "299.585px 172.409px"
    },
    className: "animable",
    id: "elgr2bdrt9jz9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,311.81l-97-56a8.6,8.6,0,0,1-4.28-7.43V219.75a3.57,3.57,0,0,1,5.36-3.09l97,56a8.6,8.6,0,0,1,4.29,7.43v28.61A3.58,3.58,0,0,1,347.54,311.81Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "299.585px 264.234px"
    },
    id: "el6op47ub6t7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,364l-97-56a8.6,8.6,0,0,1-4.28-7.43V271.94a3.57,3.57,0,0,1,5.36-3.1l97,56a8.6,8.6,0,0,1,4.29,7.43V360.9A3.58,3.58,0,0,1,347.54,364Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "299.585px 316.419px"
    },
    id: "elhf2skdq1kif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.9,384.44V400c-20.53-12.35-52.91-31.72-78.64-47.07l-5.05-3-11.42-6.82L252.63,340l-6.4-3.81V324.1a3.58,3.58,0,0,1,5.37-3.1l97,56A8.55,8.55,0,0,1,352.9,384.44Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "299.565px 360.26px"
    },
    id: "elwvotkwgv4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.26,352.93l-5.05-3-11.42-6.82L252.63,340c.32-6.35,5-8.83,10.81-5.5S274.12,346.08,274.26,352.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "263.445px 342.975px"
    },
    id: "elybzjra3c57j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.22,349.72a1.21,1.21,0,0,1,0,.19l-11.42-6.82c0-1.8,1.29-2.51,2.86-1.61a6.31,6.31,0,0,1,2.85,4.94c0-1.82,1.28-2.55,2.86-1.65A6.34,6.34,0,0,1,269.22,349.72Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "263.512px 345.5px"
    },
    id: "el2vmrou8ijbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,386a6.17,6.17,0,0,1,3.08,5.33h0a2.77,2.77,0,0,1-4.15,2.39l-59.16-35.22a6.14,6.14,0,0,1-3.08-5.33h0a2.76,2.76,0,0,1,4.14-2.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.485px 372.249px"
    },
    id: "elxmfbq4c4tis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.7,389.4a1.37,1.37,0,0,1-.7-.19l-56-33.42a1.36,1.36,0,0,1,1.39-2.33l56,33.42a1.35,1.35,0,0,1,.47,1.86A1.33,1.33,0,0,1,339.7,389.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.736px 371.357px"
    },
    id: "el8jqg6hzkw0t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.79,135.83,243.12,69.21a5.81,5.81,0,0,0-8.74,5V85h0L364.76,160.2V149.73A16.12,16.12,0,0,0,356.79,135.83Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "299.57px 114.309px"
    },
    id: "elnf4ei9pv58k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,218.17a1.93,1.93,0,0,1-1-.27l-31.56-18.22a2,2,0,0,1,2-3.46l31.56,18.22a2,2,0,0,1-1,3.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.065px 207.081px"
    },
    id: "elm6pqws3zwnh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.24,230a2,2,0,0,1-1-.27l-20.43-11.8a2,2,0,1,1,2-3.46l20.43,11.8a2,2,0,0,1-1,3.73Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "292.987px 222.079px"
    },
    id: "elykbnmhohri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.68,249.28a2,2,0,0,1-1-.27L302.24,229.7a2,2,0,1,1,2-3.46l33.45,19.3a2,2,0,0,1-1,3.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "319.936px 237.604px"
    },
    id: "elm7a3q1gwpie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.28,255.4a2,2,0,0,1-1-.27L335.69,249a2,2,0,1,1,2-3.47l10.59,6.12a2,2,0,0,1-1,3.74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "341.988px 250.33px"
    },
    id: "eljy00wgkbww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.41,335.09q27.66,16.5,55.31,33,16.15,9.64,32.3,19.32l14.43,8.66,6.43,3.86c1.92,1.16,4,2.86,6.26,3.16a6.41,6.41,0,0,0,7.12-6.31c0-.43,0-.86,0-1.3V167.88c0-5.93,0-11.86,0-17.79a17.07,17.07,0,0,0-8.49-14.86L349,130.66l-37.22-21.81L267.57,83c-8-4.67-15.9-9.43-23.92-14a6.41,6.41,0,0,0-9.77,5.66c0,2,0,3.91,0,5.86V298.24q0,9.69,0,19.4a20.06,20.06,0,0,0,9.53,17.45c.55.34,1.05-.53.5-.87-6.08-3.73-9-10-9-17v-224c0-6.15,0-12.31,0-18.46a5.76,5.76,0,0,1,1.81-4.56c2.09-1.79,4.65-1.47,6.84-.19l8.8,5.15L290,97.27l43.18,25.3c7.71,4.52,15.44,9,23.13,13.55a16.14,16.14,0,0,1,7.95,14.23V395.1c0,.54,0,1.07,0,1.6a5.39,5.39,0,0,1-8.34,4.53c-9.07-5.35-18.05-10.85-27.09-16.26q-31.35-18.78-62.72-37.5l-22.2-13.25C243.36,333.89,242.86,334.76,243.41,335.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "299.568px 235.588px"
    },
    id: "el6pvi075y6fg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.28 186.07 270.98 181.86 270.98 158.62 278.28 162.83 278.28 186.07",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "274.63px 172.345px"
    },
    id: "elhv8f7f2lhar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.04 198.06 291.74 193.85 291.74 177.46 299.04 181.68 299.04 198.06",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "295.39px 187.76px"
    },
    id: "el8qx00c4gz3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.74 192.11 281.44 187.9 281.44 154.43 288.74 158.65 288.74 192.11",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "285.09px 173.27px"
    },
    id: "elxo1rf7lmiud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.29 210.33 313 206.12 313 172.65 320.29 176.87 320.29 210.33",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "316.645px 191.49px"
    },
    id: "elcswm86v2jho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.02 216.53 323.73 212.31 323.73 172.37 331.02 176.58 331.02 216.53",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "327.375px 194.45px"
    },
    id: "elrvpf8gl5e9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.57 204.14 302.27 199.93 302.27 175.16 309.57 179.38 309.57 204.14",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "305.92px 189.65px"
    },
    id: "elsj1dx41z39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,223.21a.45.45,0,0,1-.25-.07l-82-47.34a.5.5,0,1,1,.5-.86l82,47.33a.51.51,0,0,1,.18.69A.5.5,0,0,1,342,223.21Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "300.977px 199.027px"
    },
    id: "elp7oazkzpbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.33 166.66 284.81 148.89 261.35 154.1 261.14 153.12 284.97 147.83 285.14 147.93 316.57 165.65 330.81 165.17 330.84 166.16 316.33 166.66",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "295.99px 157.245px"
    },
    id: "el499c0rawc46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.58,167.07c0,1.3-.91,1.83-2,1.18a4.52,4.52,0,0,1-2.05-3.54c0-1.3.92-1.83,2.05-1.18A4.5,4.5,0,0,1,331.58,167.07Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "329.555px 165.89px"
    },
    id: "elthsg59oeu8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,154.79c0,1.3-.92,1.83-2.05,1.18a4.54,4.54,0,0,1-2-3.54c0-1.3.92-1.83,2-1.18A4.52,4.52,0,0,1,263.29,154.79Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "261.265px 153.61px"
    },
    id: "elogh93j6cq6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.94,149.54c0,1.31-.92,1.83-2.05,1.18a4.5,4.5,0,0,1-2-3.54c0-1.3.91-1.83,2-1.18A4.52,4.52,0,0,1,286.94,149.54Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "284.915px 148.361px"
    },
    id: "elsg802rsmgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.49,167.34c0,1.3-.91,1.83-2,1.18a4.53,4.53,0,0,1-2-3.54c0-1.31.91-1.83,2-1.18A4.5,4.5,0,0,1,318.49,167.34Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "316.49px 166.159px"
    },
    id: "elcv7fj26k6ww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,249.84c0,6.91-4.85,9.71-10.84,6.26s-10.83-11.86-10.83-18.77,4.85-9.71,10.83-6.25S274.27,242.93,274.27,249.84Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "263.435px 243.587px"
    },
    id: "elht8jwhdx0wo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,302.65c0,6.92-4.85,9.72-10.84,6.26s-10.83-11.86-10.83-18.77,4.85-9.71,10.83-6.25S274.27,295.74,274.27,302.65Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "263.435px 296.4px"
    },
    id: "elcn18flx2q4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.69,238.74v8.75a.59.59,0,0,0,.66.58l7.95-.92a.59.59,0,0,0,.34-1l-7.94-7.82A.59.59,0,0,0,259.69,238.74Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "264.251px 243.114px"
    },
    id: "el73h51x2ptsd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83,291.85a4.55,4.55,0,0,1-3.1-2.85c-.09-.21-.31-.26-.31-.06v9.25a4.55,4.55,0,0,0-1-.83c-1.31-.76-2.38-.14-2.38,1.38a5.28,5.28,0,0,0,2.38,4.13c1.32.75,2.39.14,2.39-1.38V294.7a2.46,2.46,0,0,0,1.49.52,2.77,2.77,0,0,1,2.58,2.34S268.59,292.36,265.83,291.85Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "263.501px 296.002px"
    },
    id: "elpuhn3g8i1id",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,280.7a6.15,6.15,0,0,1,3.08,5.32h0a2.77,2.77,0,0,1-4.15,2.4l-59.16-34.13a6.14,6.14,0,0,1-3.08-5.33h0a2.76,2.76,0,0,1,4.14-2.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.485px 267.489px"
    },
    id: "elnb4bsherein",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,264.1a1.41,1.41,0,0,1-.68-.18L283,251.57a1.36,1.36,0,1,1,1.36-2.35l21.39,12.35a1.36,1.36,0,0,1-.68,2.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.333px 256.547px"
    },
    id: "ells7wmffzth7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,272.1a1.32,1.32,0,0,1-.68-.19l-13.85-8a1.36,1.36,0,0,1,1.36-2.35l13.85,8a1.36,1.36,0,0,1-.68,2.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "312.052px 266.758px"
    },
    id: "el6y3z05x7hta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,292.17a6.17,6.17,0,0,1,3.08,5.33h0a2.76,2.76,0,0,1-4.15,2.39l-59.16-34.13a6.13,6.13,0,0,1-3.08-5.32h0a2.76,2.76,0,0,1,4.14-2.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.485px 278.968px"
    },
    id: "elfb01kijaojm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,275.58a1.32,1.32,0,0,1-.68-.19L283,263a1.35,1.35,0,1,1,1.36-2.34l21.39,12.35a1.36,1.36,0,0,1-.68,2.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "294.372px 268.028px"
    },
    id: "eli3fn6yb8wx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.76,288.67a1.38,1.38,0,0,1-.68-.18l-22.67-13.1a1.35,1.35,0,0,1,1.36-2.34l22.67,13.09a1.36,1.36,0,0,1-.68,2.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "316.422px 280.768px"
    },
    id: "eltw6fxbuwz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,333.19a6.17,6.17,0,0,1,3.08,5.33h0a2.77,2.77,0,0,1-4.15,2.4l-59.16-34.14a6.13,6.13,0,0,1-3.08-5.32h0a2.76,2.76,0,0,1,4.14-2.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.485px 319.989px"
    },
    id: "elh84hw1wdgh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.7,336.58a1.38,1.38,0,0,1-.68-.18l-56-32.34a1.35,1.35,0,1,1,1.36-2.34l56,32.33a1.36,1.36,0,0,1-.68,2.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.695px 319.057px"
    },
    id: "eli3gdaameg4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,344.67a6.17,6.17,0,0,1,3.08,5.33h0a2.76,2.76,0,0,1-4.15,2.39l-59.16-34.13a6.14,6.14,0,0,1-3.08-5.33h0a2.76,2.76,0,0,1,4.14-2.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.485px 331.468px"
    },
    id: "el5fywfci6ks8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,328.07a1.31,1.31,0,0,1-.68-.18L283,315.54a1.36,1.36,0,0,1-.5-1.85,1.37,1.37,0,0,1,1.86-.5l21.39,12.35a1.36,1.36,0,0,1-.68,2.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "294.369px 320.541px"
    },
    id: "el395me03n4w4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "173.446px 256.066px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.15,156.61l-1.82-3.92c3.11-.06,9.52,3.87,12,5.77l17.54,15.67,5.22,18s-11.84,1.6-30.4-17.61Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "200.71px 172.426px"
    },
    id: "el0buay73jm2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.73,166.53s-9.14,3.59-11.36,16.71L184,173.89l-.69-21.2S189.18,150.8,208.73,166.53Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "196.02px 167.93px"
    },
    id: "elot10oz6f8zr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvdwuid9yfgj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.73,166.53s-9.14,3.59-11.36,16.71L184,173.89l-.69-21.2S189.18,150.8,208.73,166.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "196.02px 167.93px"
    },
    className: "animable",
    id: "el5f0bp2rfx7u"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8hkcbg4vmsw"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.43,
    y: 341.64,
    width: 14.37,
    height: 29.1,
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "182.615px 356.19px",
      transform: "rotate(178.54deg)"
    },
    className: "animable",
    id: "eld498x60zq6u"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,225s1,49.5.67,69.11c-.26,14.76-2.56,59-2.56,59s-9.32,6.09-19.14,1c0,0-5.66-44.68-4.28-58.14a22.48,22.48,0,0,0,0-4.92l-8.66-74.93Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "177.313px 286.13px"
    },
    id: "elfrzzdjh4d6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.17,366.52s-8-.91-9.57-3.5v-1.69s-1.38.74-1.12,3.54c.24,2.59-.8,7-.95,12.4a2.84,2.84,0,0,0,1.09,2.29c1.54,1.19,4.81,3,10.55,3.26,2,.09,10.07,5.26,16.78,5.26s11.09-3.33,11.09-8-13.67-8.86-13.67-8.86l-6.57-6.38s1.27-6.94-2.91-5.27S185.17,363,185.17,366.52Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "193.285px 373.695px"
    },
    id: "el1xetpnn082g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66,370.54a.3.3,0,0,1-.13,0,.43.43,0,0,1-.28-.54,8.68,8.68,0,0,1,6.48-5.54.42.42,0,0,1,.49.35.43.43,0,0,1-.35.5,7.94,7.94,0,0,0-5.8,5A.43.43,0,0,1,186.66,370.54Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "189.728px 367.5px"
    },
    id: "elipptl39vtk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.28,373.17l-.13,0a.43.43,0,0,1-.27-.55,8.61,8.61,0,0,1,6.47-5.53.43.43,0,0,1,.14.84,7.94,7.94,0,0,0-5.8,5A.44.44,0,0,1,189.28,373.17Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "192.323px 370.13px"
    },
    id: "ely092f2hxvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.6,375.42a.3.3,0,0,1-.13,0,.43.43,0,0,1-.28-.54,8.66,8.66,0,0,1,6.48-5.54.43.43,0,0,1,.14.85,7.92,7.92,0,0,0-5.8,5A.43.43,0,0,1,191.6,375.42Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "194.669px 372.381px"
    },
    id: "eleqi7h6j4gtt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,380.11c0,4.59-4.29,7.89-10.87,8l-9.4-3.77c0-9.74,6.6-13.05,6.6-13.05S213,375.46,213,380.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "202.865px 379.7px"
    },
    id: "elgu19n8dogx6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.76,377.67c1.61,1.25,5,3.16,11,3.42,2.11.09,10.53,5.5,17.55,5.5,4.82,0,8.48-1.64,10.31-4.24-1.19,3.43-5.14,5.73-10.71,5.73-6.71,0-14.76-5.17-16.78-5.26-5.74-.25-9-2.07-10.55-3.26a2.83,2.83,0,0,1-1.07-2.09A2,2,0,0,0,173.76,377.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.065px 382.775px"
    },
    id: "elfy615vahpch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,232s-1.31,11.2-9.9,17.12l-7.58,38-4.87-47.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "174.435px 259.56px"
    },
    id: "elri66il0erzb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elftm3km7pq5k"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.11,
    y: 350.32,
    width: 14.37,
    height: 29.1,
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "142.295px 364.87px",
      transform: "rotate(-175.53deg)"
    },
    className: "animable",
    id: "ellfkjek3i60n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,226.18s-1.73,6.56-2.58,33.64c-.66,21.46-1.17,33.8-1.34,38a24.85,24.85,0,0,1-.34,3.11A306.69,306.69,0,0,0,134,333.65c-1.23,20.86-1.32,30.77-1.32,30.77s8.86,6.92,19.55,1.49l10.34-62.23L173.43,246s14.94-5.7,16.26-20.91Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "161.185px 296.54px"
    },
    id: "elyl8zo7bqxyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52,372.16,134.3,375a9.61,9.61,0,0,0,3.72,3.1s1.54-5.64,4.28-5.93,8.4-.54,7.64,2.6a25.36,25.36,0,0,0-.79,5l5.26,9.82s10.69,9.2,6.22,15.07-19.46,2.74-20.93-6.48a10.24,10.24,0,0,0-4.48-6.84,5.64,5.64,0,0,1-2.55-5.87c.27-2.1.91-6.15.71-8S132.68,372.18,134.52,372.16Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "147.144px 389.825px"
    },
    id: "elz8ks7r70re",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.63,404.64c-3.71,4.88-14.66,3.54-19.12-2.33a14.08,14.08,0,0,1-.3-2.89c0-10.48,13.2-9.85,13.2-9.85S165.1,398.77,160.63,404.64Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "151.466px 398.593px"
    },
    id: "el7lwdt7vpcx3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.67,385.45c0-.15,0-.34.06-.51a5.67,5.67,0,0,0,2.64,4.1,10.58,10.58,0,0,1,4.64,7.07c1.51,9.42,16.67,12.69,21.47,6.89a5,5,0,0,1-.85,1.64c-4.47,5.88-19.46,2.74-20.93-6.48a10.24,10.24,0,0,0-4.48-6.84A5.64,5.64,0,0,1,132.67,385.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.022px 396.283px"
    },
    id: "elcv6jyqrcnyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39,382a.42.42,0,0,1-.31-.13.43.43,0,0,1,0-.61,8.62,8.62,0,0,1,8.33-1.82.43.43,0,0,1-.28.81,7.94,7.94,0,0,0-7.46,1.63A.4.4,0,0,1,141.39,382Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "145.31px 380.525px"
    },
    id: "elr1slyij1j6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,385.6a.45.45,0,0,1-.32-.14.43.43,0,0,1,0-.6,8.61,8.61,0,0,1,8.32-1.82.42.42,0,0,1,.27.54.43.43,0,0,1-.54.27c-.05,0-4.27-1.38-7.46,1.63A.42.42,0,0,1,143.22,385.6Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "147.146px 384.125px"
    },
    id: "el8cp3gnoatw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,389.24a.44.44,0,0,1-.31-.14.43.43,0,0,1,0-.6,8.61,8.61,0,0,1,8.32-1.82.43.43,0,1,1-.28.81,7.92,7.92,0,0,0-7.45,1.63A.44.44,0,0,1,145,389.24Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "148.951px 387.765px"
    },
    id: "elnettnq85as",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,155.06,146.82,158l-5,27.13,3,13.15a15.24,15.24,0,0,1,.22,5.47l-3.2,22.48S150.9,232,167.56,232,193.93,225,193.93,225l-1.26-51.18a33.28,33.28,0,0,0-9.34-21.17h0L172,154Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "167.875px 192.325px"
    },
    id: "el0qvw7vtq3prb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.88,112s8.77,7.69,1.15,24.83l-8.91-23.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "183.131px 124.415px"
    },
    id: "el9l0yikf6d7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.98 155.06 166.75 160.71 171.96 154.01 171.96 133.32 155.98 133.32 155.98 155.06",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "163.97px 147.015px"
    },
    id: "ell8lhlm9342q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,152.69c-5.39,0-13.57-4.8-13.57-8.14l-1.8-11.23H172Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "164.315px 143.005px"
    },
    id: "elrftbxgoa2ei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.71,107.26c5.38,0,16.81,3,18.13,17.06s-.74,26-7.22,26c-12.71,0-24.92-1.62-25-22.42C153.51,109.58,162.47,107.26,167.71,107.26Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "169.919px 128.79px"
    },
    id: "elzay447o03wk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,140.25l2.08-6.35a1.07,1.07,0,0,0,1.75-.82V121.75s5.29-1.5,4.73-6c0,0,2.7,2.42,13.08,2.42s12.89-8.79,11.85-13.68c0,0-1.92,2-7.41,2s-28.31-6.89-28.9,6.91c0,0-1.93-2.83-5,0l4,2.37s-4.74-.15-4,6.82c.49,4.58,2.16,12.6,3.25,17.55a11,11,0,0,0,4.61,6.77h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "168.904px 125.7px"
    },
    id: "eldf2p06kzwkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.58 128.54 175.58 137.58 180.87 135.95 175.58 128.54",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "178.225px 133.06px"
    },
    id: "elftauxhd77a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,130a1.69,1.69,0,1,0,1.69-1.69A1.69,1.69,0,0,0,167.17,130Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "168.86px 130px"
    },
    id: "elhpvc2397cju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81,128.8a1.69,1.69,0,1,0,1.69-1.69A1.69,1.69,0,0,0,179.81,128.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.5px 128.8px"
    },
    id: "eldz7xghkqlls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.56,125.28l-3.3-2s1.27-1.32,2.53-.53A2.31,2.31,0,0,1,183.56,125.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.966px 123.889px"
    },
    id: "el00s0rf9ho8b8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,126.5l3.31-2s-1.27-1.32-2.54-.53A2.31,2.31,0,0,0,165.42,126.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.019px 125.109px"
    },
    id: "el0f3hjkv1mkyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.15,141.92s-2.45-1.58-4.81-3.34c0,0-1.37,2.67.78,4S175.15,141.92,175.15,141.92Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "172.53px 140.809px"
    },
    id: "el86exectrzst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.2 134 152.35 127.65 156.55 125.13 158.2 134",
    style: {
      fill: "rgb(37, 50, 57)",
      transformOrigin: "155.275px 129.565px"
    },
    id: "elt562zrw6t2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.23,131.53c1.92,3.31,1.43,7.34-1.25,8.72-1.71.89-6.78-1-8.7-4.34s-.83-6.16,1.77-7.67S155.32,128.21,157.23,131.53Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "152.349px 134.059px"
    },
    id: "elgtno7iv24qe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,154l2.18,3.46a5.59,5.59,0,0,1-2.28,8h0a10.24,10.24,0,0,1-14.09-5.64L156,155.06l8-3.46Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "165.519px 159.048px"
    },
    id: "el4d8cczwtudt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.47 191.39 141.44 199.89 120.75 208.07 129.09 182.8 145.47 191.39",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "133.11px 195.435px"
    },
    id: "elwzmbh9j1mr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,157.57s6.9,7.09,3.92,17.08a105,105,0,0,1-6.49,16.74s-11.63.35-16.37-8.59l5.92-15a16.22,16.22,0,0,1,10.86-9.69Z",
    style: {
      fill: "#1AB1AD",
      transformOrigin: "140.863px 174.481px"
    },
    id: "elb7w3xby398",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpod5dwsgcpo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,157.57s6.9,7.09,3.92,17.08a105,105,0,0,1-6.49,16.74s-11.63.35-16.37-8.59l5.92-15a16.22,16.22,0,0,1,10.86-9.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "140.863px 174.481px"
    },
    className: "animable",
    id: "ele14lw1vg848"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.6,198.31,122,204.41s-.12.33-1.21,3.67c-1.67,5.13,3.61,17.54,22.4,8.53s25.63-13.83,25.63-13.83l-2-11.39S148.57,196.56,142.6,198.31Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "144.66px 205.595px"
    },
    id: "el8f9ffsipdci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.05 198.57 132.32 201.38 143.21 196.13 142.05 198.57",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "137.765px 198.755px"
    },
    id: "elr8ocxxzlocj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,207.9l12.2-1.3a2.18,2.18,0,0,0,1.87-1.6l6.66-25.09a1.13,1.13,0,0,0-1.14-1.42l-11.8.55a2.09,2.09,0,0,0-1.91,1.53l-7.1,25.9A1.14,1.14,0,0,0,169.65,207.9Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "179.404px 193.198px"
    },
    id: "elp0tz8cimp2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,182.19a1.05,1.05,0,1,0,1-1.06A1,1,0,0,0,185.61,182.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "186.659px 182.179px"
    },
    id: "eld278529j42d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.75,191.39s3.52-6.14,7.91-7.63l-1.76,6.75s3.33.26,7.1.26,7.89-2.53,9.12-3.19,2.3,3.91-2.45,12.49-17.89,2.71-17.89,2.71Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "178.459px 194.25px"
    },
    id: "eliz9n8if0rk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.15,162.9,196,155.35l7.28.33s19.18,16.87,21.39,20.6,4.14,14.47-6.63,15.81l-3.14-2.47a32.53,32.53,0,0,1-8.24-9.65Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "211.196px 173.72px"
    },
    id: "el6ask3pjnu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,149.29s-2.59-5.87-3.06-7.28c-.68-2-2.43-.85-2.92.48s.08,2.77,1.29,4.68S198.39,149.29,198.39,149.29Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "195.312px 145.111px"
    },
    id: "el4lbrq32cp0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.15,162.9s-6.2-.37-10-4.38l4.66-9.09s-7.13-1.9-9.3-3.58-.91-2.78.27-2.68c1,.09,10.53,2.46,12.75,3.51,1.85.89,4.39,3.31,7.74,9l3.8,10.18Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "194.199px 154.512px"
    },
    id: "el2rlsvjqpa1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.85,149.43s-3.76-3-5.23.66-3.22,5.16-2.39,6.75,5.09,8.44,6.39,4.21S191.85,149.43,191.85,149.43Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "187.933px 155.341px"
    },
    id: "el535lji1shex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.73,183.48a.35.35,0,0,1-.27-.13,33.71,33.71,0,0,1-2.05-3.22L197,163.21a19,19,0,0,1-6.14-1.71,1.83,1.83,0,0,1-1.1,1.18.32.32,0,0,1-.4-.22.32.32,0,0,1,.22-.41c.32-.09.58-.46.78-1.09a.18.18,0,0,1,0-.1.32.32,0,0,1,.42-.11,18.41,18.41,0,0,0,6.4,1.82.35.35,0,0,1,.27.17L207,179.81a31.14,31.14,0,0,0,2,3.15.32.32,0,0,1-.07.46A.35.35,0,0,1,208.73,183.48Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "199.206px 172.096px"
    },
    id: "elk9e2pabuws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.62,161.37a.37.37,0,0,1-.18-.05,16.45,16.45,0,0,1-3-2.66.33.33,0,1,1,.52-.4,15.92,15.92,0,0,0,2.88,2.51.33.33,0,0,1,.08.46A.32.32,0,0,1,190.62,161.37Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "189.164px 159.737px"
    },
    id: "els6yghlgvw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,149.75a.3.3,0,0,1-.18-.06.33.33,0,0,1-.1-.45,2.82,2.82,0,0,1,.76-.81,19.69,19.69,0,0,1-5.1-2.32c-1.47-1.14-1.39-2-1.21-2.44a1.62,1.62,0,0,1,1.73-.83c.63.09,7.43,1.95,12.49,3.33a8.34,8.34,0,0,1,3.06,2.25.34.34,0,0,1,0,.47.32.32,0,0,1-.46,0,8.08,8.08,0,0,0-2.78-2.07c-7.77-2.12-11.94-3.23-12.38-3.3a1,1,0,0,0-1,.43c-.17.42.21,1,1,1.67a22.23,22.23,0,0,0,5.69,2.48.32.32,0,0,1,.22.32.33.33,0,0,1-.24.31,2,2,0,0,0-1.18.9A.34.34,0,0,1,187,149.75Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "189.809px 146.283px"
    },
    id: "el4mp4ymf8pkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.08,150.19a.27.27,0,0,1-.12,0l-3.75-1.48a.31.31,0,0,1-.18-.42.33.33,0,0,1,.42-.19l3.76,1.48a.34.34,0,0,1,.18.43A.33.33,0,0,1,192.08,150.19Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "190.207px 149.138px"
    },
    id: "elvaprsm6ekr",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorysetAppData31399);
export default __webpack_public_path__ + "static/media/storyset_app_data_31399.467d6f983844759f2bfd3fb368e0cc9c.svg";
export { ForwardRef as ReactComponent };